import React, {Fragment} from "react";

import {Badge, BadgeVariantsUnionType} from "@pg-design/badge-module";

import * as styles from "./GalleryPicture.module.css";

export interface IGalleryPicture {
    imgAlt?: string;
    onClick: () => void;
    srcSm?: string;
    srcMd?: string;
    srcLg?: string;
    tags?: {
        label: string;
        variant: BadgeVariantsUnionType;
        icon?: (props: {fill: string; className: string; size?: string}) => React.ReactElement;
    }[];
    onLoad?: () => void;
}

export const GalleryPicture = (props: IGalleryPicture) => {
    const {onClick, srcSm, srcMd, srcLg, tags, onLoad, imgAlt} = props;

    return (
        <div className={styles.wrapper}>
            {tags && (
                <div className={styles.tags}>
                    {tags.map((tag, index) => (
                        <Badge variant={tag.variant} icon={tag.icon} iconSize="1.5" key={index}>
                            {tag.label}
                        </Badge>
                    ))}
                </div>
            )}

            <picture className={styles.galleryImageHolder}>
                {srcLg && <source media="(min-width: 1920px)" srcSet={srcLg} />}

                {srcMd && (
                    <Fragment>
                        <source media="(min-width: 1400px)" srcSet={srcMd} />
                        <source media="(min-width: 480px)" srcSet={srcMd} />
                    </Fragment>
                )}

                {srcSm && (
                    <Fragment>
                        <source media="(min-width: 1024px)" srcSet={srcSm} />
                        <source media="(min-width: 768px)" srcSet={srcSm} />
                    </Fragment>
                )}

                <img src={srcSm} alt={imgAlt} loading="lazy" onClick={onClick} onLoad={onLoad} />
            </picture>
        </div>
    );
};
import React, {Fragment} from "react";

import {Badge, BadgeVariantsUnionType} from "@pg-design/badge-module";

import * as styles from "./GalleryPicture.module.css";

export interface IGalleryPicture {
    imgAlt?: string;
    onClick: () => void;
    srcSm?: string;
    srcMd?: string;
    srcLg?: string;
    tags?: {
        label: string;
        variant: BadgeVariantsUnionType;
        icon?: (props: {fill: string; className: string; size?: string}) => React.ReactElement;
    }[];
    onLoad?: () => void;
}

export const GalleryPicture = (props: IGalleryPicture) => {
    const {onClick, srcSm, srcMd, srcLg, tags, onLoad, imgAlt} = props;

    return (
        <div className={styles.wrapper}>
            {tags && (
                <div className={styles.tags}>
                    {tags.map((tag, index) => (
                        <Badge variant={tag.variant} icon={tag.icon} iconSize="1.5" key={index}>
                            {tag.label}
                        </Badge>
                    ))}
                </div>
            )}

            <picture className={styles.galleryImageHolder}>
                {srcLg && <source media="(min-width: 1920px)" srcSet={srcLg} />}

                {srcMd && (
                    <Fragment>
                        <source media="(min-width: 1400px)" srcSet={srcMd} />
                        <source media="(min-width: 480px)" srcSet={srcMd} />
                    </Fragment>
                )}

                {srcSm && (
                    <Fragment>
                        <source media="(min-width: 1024px)" srcSet={srcSm} />
                        <source media="(min-width: 768px)" srcSet={srcSm} />
                    </Fragment>
                )}

                <img src={srcSm} alt={imgAlt} loading="lazy" onClick={onClick} onLoad={onLoad} />
            </picture>
        </div>
    );
};
